import * as tslib_1 from "tslib";
import { Router } from "@angular/router";
// Third party packages
// Custom packages
import { isArchiveV3Live } from "src/app/shared/utils/archive-switch.utils";
import { ARCHIVE_V3_REDIRECT_DATA_KEY, archiveV3RedirectCommands, } from "src/app/shared/utils/archive-v3-redirect.utils";
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
/**
 * The language of the address, the `:lang` parameter of the root route.
 *
 * A child route does not inherit the parameters of the routes above it (the router's default
 * `paramsInheritanceStrategy`), so it is looked for along the whole path, from the root down.
 *
 * @since 3.0.0
 *
 * @param route The route being activated
 * @returns The language, or null when no route of the path carries one
 */
export function archiveRouteLang(route) {
    var e_1, _a;
    var path = route && Array.isArray(route.pathFromRoot) ? route.pathFromRoot : [];
    try {
        for (var path_1 = tslib_1.__values(path), path_1_1 = path_1.next(); !path_1_1.done; path_1_1 = path_1.next()) {
            var step = path_1_1.value;
            var lang = step && step.params ? step.params.lang : undefined;
            if (typeof lang === "string" && lang) {
                return lang;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (path_1_1 && !path_1_1.done && (_a = path_1.return)) _a.call(path_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return null;
}
/**
 * Sends a legacy page of the archive on to its 3.0.0 successor once the archive is live (FE-A1),
 * @see ARCHIVE_V3_REDIRECT_DATA_KEY for the addresses and the rule.
 *
 * It goes FIRST in the `canActivate` of the legacy route, before the guards of that page:
 *
 *   {
 *     path: ":propertyId/documents",
 *     component: PropertyDocumentsComponent,
 *     canActivate: [ArchiveV3RedirectGuard, RoleGuard],
 *     data: { properties: [...], archiveV3Redirect: ARCHIVE_V3_PROPERTY_DOCUMENTS },
 *   }
 *
 * The router reads the guards of a route in their order and follows the first one that answers a
 * redirect, so the legacy page is never built while the switch is on; the guards of the new page then
 * decide whether the user may open it. While the switch is off it answers true and the legacy page
 * opens exactly as before, its own guards deciding.
 *
 * @since 3.0.0
 */
var ArchiveV3RedirectGuard = /** @class */ (function () {
    /**
     * Class constructor
     */
    function ArchiveV3RedirectGuard(router) {
        this.router = router;
    }
    /**
     * The address of the new page while the archive is live and the route names one; true otherwise.
     *
     * @since 3.0.0
     *
     * @param route The legacy route being activated
     */
    ArchiveV3RedirectGuard.prototype.canActivate = function (route) {
        var data = route && route.data ? route.data : {};
        var commands = archiveV3RedirectCommands(this.archiveLive(), data[ARCHIVE_V3_REDIRECT_DATA_KEY], route ? route.params : null, archiveRouteLang(route));
        if (!commands) {
            return true;
        }
        return this.router.createUrlTree(commands, {
            queryParams: route.queryParams,
        });
    };
    /**
     * Whether the 3.0.0 archive is live in this build: a method of its own, so that a test can turn
     * the switch on without touching the environment files.
     *
     * @since 3.0.0
     */
    ArchiveV3RedirectGuard.prototype.archiveLive = function () {
        return isArchiveV3Live();
    };
    ArchiveV3RedirectGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ArchiveV3RedirectGuard_Factory() { return new ArchiveV3RedirectGuard(i0.ɵɵinject(i1.Router)); }, token: ArchiveV3RedirectGuard, providedIn: "root" });
    return ArchiveV3RedirectGuard;
}());
export { ArchiveV3RedirectGuard };
